var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSouthKorea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6042_110711)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6663 7.99844C14.6663 10.0603 13.0247 11.7318 10.9997 11.7318C8.97463 11.7318 7.33301 10.0603 7.33301 7.99844C7.33301 6.80377 9.79491 6.30244 11.8671 6.49124C12.0871 6.4315 12.3239 6.39844 12.5711 6.39844C13.7287 6.39844 14.6663 7.11524 14.6663 7.99844Z",
    fill: "#232C80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4759 7.46563C10.4759 7.46563 11.4135 6.39896 12.5711 6.39896C13.7287 6.39896 14.6663 7.11576 14.6663 7.99896C14.6663 5.93709 13.0247 4.26562 10.9997 4.26562C9.53615 4.26562 8.27272 5.13816 7.68501 6.40109C7.33301 7.46563 7.33301 7.77709 7.33301 7.99896C7.85682 8.53229 8.43929 8.53229 8.90444 8.53229C9.36958 8.53229 9.78758 8.32643 10.0757 7.99896L10.4759 7.46563Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7142 5.33646H17.8095L15.7142 3.20312H14.6666L15.7142 5.33646ZM6.28567 5.33646H4.19043L6.28567 3.20312H7.33329L6.28567 5.33646ZM15.7142 10.6698H17.8095L15.7142 12.8031H14.6666L15.7142 10.6698ZM6.28567 10.6698H4.19043L6.28567 12.8031H7.33329L6.28567 10.6698Z",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6042_110711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSouthKorea);
export default __webpack_public_path__ + "static/media/icon-south-korea.c8f77faba86166ea4040032ad6dd4e25.svg";
export { ForwardRef as ReactComponent };